import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { KpiDTO } from '../../types/dto';
import KeyValueTable from './KeyValueTable';

interface OwnProps {
  data: KpiDTO[];
}

type Props = OwnProps;

const NewCustomers: FunctionComponent<Props> = ({ data }) => {
  const { t } = useTranslation();

  return (
    <KeyValueTable data={data} title={t('dashboard_newCustomers')} />
  );
};

export default NewCustomers;
